export type VercelEnv = 'development' | 'preview' | 'production';

export const vercelGitCommitRef =
  process.env.VERCEL_GIT_COMMIT_REF ??
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF;
export const vercelEnv = (process.env.VERCEL_ENV ??
  process.env.NEXT_PUBLIC_VERCEL_ENV) as VercelEnv;
export const isDevelopment =
  process.env.NODE_ENV === 'development' || vercelEnv === 'development';
export const isPreview = vercelEnv === 'preview';
export const isProduction = vercelEnv === 'production';
export const isUat = vercelGitCommitRef === 'uat';
export const isProductionLike = isProduction || isUat;
